/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
*/
import { Dic } from '$utils'
import i18n from '@src/common/lib/i18n'

export const filterOps =() =>{
  return [{
  label: i18n.t('carPatrolBlack.label.number'),
  prop: 'plateCode',
  span: 8,
  placeholder:i18n.t('carPatrolBlack.placeholder.number')
},
// {
//   label: i18n.t('carPatrolBlack.label.createDate'),
//   prop: 'timeData',
//   type: 'daterange',
//   span: 8,
//   startPlaceholder: i18n.t('carPatrolBlack.placeholder.startTime'),
//   endPlaceholder: i18n.t('carPatrolBlack.placeholder.endTime'),
//   valueFormat: 'yyyy-MM-dd HH:mm:ss'
// },
 {
  label: i18n.t('carPatrolBlack.label.owner'),
  prop: 'ownerName',
  span: 8,
  placeholder:i18n.t('carPatrolBlack.placeholder.owner')
}, {
  label: i18n.t('carPatrolBlack.label.color'),
  prop: 'vehicleColor',
  span:  8,
  type: 'select',
  dicData: [{label: i18n.t('carPatrolBlack.label.unlimit'), value: -1}].concat(Dic.find('SENU039')),
  placeholder:i18n.t('carPatrolBlack.placeholder.color')
}, {
  label: i18n.t('carPatrolBlack.label.type'),
  prop: 'vehicleType',
  span: 8,
  type: 'select',
  dicData: Dic.find('SENU038'),
  placeholder:i18n.t('carPatrolBlack.placeholder.type')
}, {
  label: '',
  prop: 'operation',
  span: 8,
  formslot: true
}]
}
